var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoneBrokenRebrand = function SvgBoneBrokenRebrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 37 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Bone-broken-rebrand_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M34.544 13.246a5.07 5.07 0 0 1-3.657 1.556 5.26 5.26 0 0 1-2.993-.919l-5.113 5.104-3.758-.127.046-1.765.046-2.193-3.885.11 6.896-6.897a5 5 0 0 1-.919-2.993c0-1.401.573-2.693 1.556-3.657 1.938-1.902 5.03-1.947 7.05-.146a5.3 5.3 0 0 1 1.675 3.212h.045a5.2 5.2 0 0 1 3.166 1.674c1.81 2.01 1.747 5.113-.127 7.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M13.883 27.894c.619.873.937 1.91.937 2.993 0 1.401-.573 2.693-1.565 3.657A5.13 5.13 0 0 1 9.663 36c-1.301 0-2.466-.446-3.457-1.328a5.2 5.2 0 0 1-1.629-2.957 3 3 0 0 1-.045-.255 5.16 5.16 0 0 1-3.221-1.674c-1.81-2.001-1.747-5.113.146-7.05a5.08 5.08 0 0 1 3.657-1.566h.045c1.065 0 2.102.319 2.966.928l5.432-5.431 3.884-.11-.045 2.23-.046 1.874 3.63.127-7.087 7.087-.018.019z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "m20.97 20.807-7.087 7.087c.61.873.937 1.91.937 2.993a5.13 5.13 0 0 1-1.555 3.657A5.12 5.12 0 0 1 9.662 36a5.2 5.2 0 0 1-3.457-1.328 5.24 5.24 0 0 1-1.629-2.957l12.8-12.928-.045 1.874 3.63.118v.028zM34.544 13.246a5.07 5.07 0 0 1-3.657 1.556 5.26 5.26 0 0 1-2.993-.919l-5.113 5.113-3.757-.127.045-1.774L31.515 4.54a5.15 5.15 0 0 1 3.166 1.665c1.81 2.01 1.747 5.113-.127 7.06"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Bone-broken-rebrand_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36.027v36H0z"
  })))));
};
export default SvgBoneBrokenRebrand;